import React, { useEffect, useState } from 'react';
import { Button, IconButton, TextField } from '@mui/material';
import { ReactComponent as SearchIcon } from '../../../../assets/images/Search.svg';
import { Pagination } from '../../../../components';
import CratePopup from './createPopup';
import { useHook as EquipmentsDashboard } from '../equipments/useHook';
import { ArrowDropDown, ArrowDropUp } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { useHook as CategoryHook } from './useHook';
import useDebounce from '../../../../components/Debounce';
import Popup from '../../../../components/Popup';
import emptyFolter from '../../../../assets/images/empty-folder 2.svg';
import { Unauthorized } from '../../../../components/index';
import { ErrorMessage } from '../../../../permissionErrorMessage/PermissionMessage';
interface Props {
  pagePermissionIDs: unknown;
}

const Category: React.FC<Props> = ({ pagePermissionIDs }) => {
  const canCreateCategory =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('categories::create');
  const canCreateSubCategory =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('categories::subCategoryCreate');
  const canDeleteCategory =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('categories::delete');
  const canDeleteSubCategory =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('categories::subCategoryDelete');
  const canlistPermission =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('categories::list');

  const requiredAccess = (
    <section className="required_access_section">
      <p>you require below access:</p>
      <ul>
        <li>{ErrorMessage['categories::list'] || ''}</li>
      </ul>
    </section>
  );

  const { fetchCategoryList, handleDeleteCategory, handleDeleteSubCategory } =
    CategoryHook();
  const { createCategory, createSubCategory, fetchGetListCategory } =
    EquipmentsDashboard();
  const { categoryList } = useSelector((state: any) => state.equipments);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [expanded, setExpanded] = useState<number[]>([]);
  const [createPopup, setCreatePopup] = useState(false);
  const [search, setSearch] = useState<string>('');
  const debouncedSearch = useDebounce(search, 1000);
  const [selectCategoryId, setSelectCategoryId] = useState('');

  const [deleteCategoryId, setDeleteCategoryId] = useState('');
  const [deleteCategoryPopup, setDeleteCategoryPopup] = useState(false);
  const [deleteSubCategoryName, setDeleteSubCategoryName] = useState('');
  const [deleteSubCategoryPopup, setDeleteSubCategoryPopup] = useState(false);

  const deleteCategory = (id: string) => {
    setDeleteCategoryId(id);
    setDeleteCategoryPopup(true);
  };
  const handleCloseCategoryPopup = () => {
    setDeleteCategoryId('');
    setDeleteCategoryPopup(false);
  };
  const categoryDeleteConform = async () => {
    setExpanded([]);
    await handleDeleteCategory({ categoryId: deleteCategoryId });
    setDeleteCategoryId('');
    setDeleteCategoryPopup(false);
    getData(1, rowsPerPage, search);
    setCurrentPage(1);
    await fetchGetListCategory({});
  };

  const deleteSubCategory = (id: string, name: string) => {
    setDeleteCategoryId(id);
    setDeleteSubCategoryName(name);
    setDeleteSubCategoryPopup(true);
  };
  const handleCloseSubCategoryPopup = () => {
    setDeleteCategoryId('');
    setDeleteSubCategoryName('');
    setDeleteSubCategoryPopup(false);
  };
  const subcategoryDeleteConform = async () => {
    setExpanded([]);
    await handleDeleteSubCategory({
      categoryId: deleteCategoryId,
      name: deleteSubCategoryName,
    });
    setDeleteCategoryId('');
    setDeleteSubCategoryName('');
    setDeleteSubCategoryPopup(false);
    getData(1, rowsPerPage, search);
    setCurrentPage(1);
    await fetchGetListCategory({});
  };

  const handleCreateCategory = async (data: any) => {
    if (data?.categoryID) {
      await createSubCategory(data);
    } else {
      await createCategory(data);
    }
    setCurrentPage(1);
    setCreatePopup(false);
    setSelectCategoryId('');
    setSearch('');
    setExpanded([]);
    getData(1, rowsPerPage, '');
    await fetchGetListCategory({});
  };

  useEffect(() => {
    if (debouncedSearch) {
      getData(1, rowsPerPage, search);
      setCurrentPage(1);
    }
  }, [debouncedSearch]);

  const handleCloseCrateCategory = () => {
    setCreatePopup(false);
    setSelectCategoryId('');
  };

  const handleClickSubCategory = (id: string) => {
    setSelectCategoryId(id);
    setCreatePopup(true);
  };
  const toggleExpanded = (index: number) => {
    if (expanded?.includes(index)) {
      const removedExpand = expanded.filter((item: number) => item !== index);
      setExpanded(removedExpand);
    } else {
      setExpanded([...expanded, index]);
    }
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    getData(page, rowsPerPage, search);
    setExpanded([]);
  };
  const handleRowsPerPageChange = (value: number) => {
    getData(1, value, search);
    setRowsPerPage(value);
    setCurrentPage(1);
  };
  useEffect(() => {
    getData();
  }, [canlistPermission]);

  const getData = async (
    pagenumber?: number,
    row_perpage?: number,
    search: unknown = '',
    sort: { orderBy: string; order: number } = {
      orderBy: 'updatedAt',
      order: -1,
    },
  ) => {
    const payload = {
      sort: sort,
      search: search,
      limit: row_perpage ? row_perpage : rowsPerPage,
      offset: pagenumber
        ? (pagenumber - 1) * rowsPerPage
        : (currentPage - 1) * rowsPerPage,
    };
    if (canlistPermission) {
      await fetchCategoryList(payload).then((res: any) => {
        const totalPage = res?.count
          ? Math.ceil(res?.count / (row_perpage ? row_perpage : rowsPerPage))
          : 1;
        setTotalPages(totalPage);
      });
    }
  };

  const handleSearchChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const search = event.target.value;
    // Allow only letters, numbers, and spaces
    const regex = /^[a-zA-Z0-9 ]*$/;
    if (regex.test(search)) {
      setSearch(search);
      setExpanded([]);
      if (!search) {
        getData(currentPage, rowsPerPage, search);
      } else {
        setCurrentPage(1);
      }
    }
  };

  return (
    <>
      {!canlistPermission ? (
        <Unauthorized requiredAccess={requiredAccess} />
      ) : (
        <>
          {deleteCategoryPopup && (
            <Popup
              open={deleteCategoryPopup}
              btntext="delete"
              handleClose={handleCloseCategoryPopup}
              handleDelete={categoryDeleteConform}
              page="category"
            />
          )}
          {deleteSubCategoryPopup && (
            <Popup
              open={deleteSubCategoryPopup}
              btntext="delete"
              handleClose={handleCloseSubCategoryPopup}
              handleDelete={subcategoryDeleteConform}
              page="subCategory"
            />
          )}
          {createPopup && (
            <CratePopup
              open={createPopup}
              handleClose={handleCloseCrateCategory}
              handleCreate={handleCreateCategory}
              categortText={
                selectCategoryId.trim().length > 0 ? 'SubCategory' : 'Category'
              }
              categoryId={selectCategoryId}
            />
          )}
          <div className="controller_header equipment_header flex-wrap flex-md-nowrap">
            <div>
              {/* <ActionButtons
            image={Filter}
            title={'Filters'}
            action={fliterOpenDrawer}
            activeData={[]}
          /> */}
            </div>
            <div className="table-header-btn">
              <TextField
                variant="outlined"
                placeholder="Search"
                value={search}
                onChange={handleSearchChange}
                InputProps={{
                  startAdornment: <SearchIcon />,
                }}
                className="search-input"
              />
              {canCreateCategory && (
                <Button
                  className="create-btn create-equipment-btn"
                  color="primary"
                  onClick={() => setCreatePopup(true)}
                >
                  Create Category
                </Button>
              )}
            </div>
          </div>

          <div className="hardware-equipment">
            <div className="equipment-controller">
              <div className="equipment_controller-body">
                <div className="equipment-body_Parameters">
                  {/* <div className="category_header">
                <h5>Assistant Controller</h5>
                <div className="controller_header">
                  <h4>SPORTSMAN XP 1000 </h4>
                </div>
              </div> */}
                  {categoryList?.length > 0 ? (
                    categoryList?.map((category: any, index: number) => (
                      <div
                        key={index}
                        className="equipment-body_Parameters-param"
                      >
                        <div className="equipment-body_Parameters-param-header">
                          <div className="equipment-body_Parameters-content">
                            <IconButton
                              className="category_expanded-btn"
                              onClick={() => toggleExpanded(index)}
                            >
                              {expanded?.includes(index) ? (
                                <ArrowDropUp />
                              ) : (
                                <ArrowDropDown />
                              )}
                            </IconButton>
                            <h4>{category?.categoryName}</h4>
                          </div>
                          <div className="category_edit_delete-btns">
                            {canDeleteCategory && (
                              <Button
                                className="btn-transparent border-0 img-background-form"
                                onClick={() =>
                                  deleteCategory(category?.categoryID)
                                }
                              >
                                <i className="delete-icon bi bi-trash3-fill bi-lg"></i>
                              </Button>
                            )}
                          </div>
                        </div>
                        {expanded.includes(index) && (
                          <div
                            className={
                              category?.subCategories?.length > 0
                                ? 'category_list-sub_category'
                                : 'category_list-sub_category-nodata'
                            }
                          >
                            {category?.subCategories?.length > 0 && (
                              <>
                                <h5 className="category_list-sub_category-heading">
                                  Subcategory
                                </h5>
                                {category?.subCategories?.map(
                                  (subcategory: string, index: number) => (
                                    <div
                                      className="category_list-sub_category-data"
                                      key={index}
                                    >
                                      <p>{subcategory}</p>

                                      <div className="category_list-sub_category-btn">
                                        {canDeleteSubCategory && (
                                          <Button
                                            className="btn-transparent border-0 img-background-form"
                                            onClick={() =>
                                              deleteSubCategory(
                                                category?.categoryID,
                                                subcategory,
                                              )
                                            }
                                          >
                                            <i className="delete-icon bi bi-trash3-fill bi-lg"></i>
                                          </Button>
                                        )}
                                      </div>
                                    </div>
                                  ),
                                )}
                              </>
                            )}
                            {canCreateSubCategory && (
                              <Button
                                className="category_list-sub_category-addmore"
                                onClick={() =>
                                  handleClickSubCategory(category?.categoryID)
                                }
                              >
                                + Add More
                              </Button>
                            )}
                          </div>
                        )}
                      </div>
                    ))
                  ) : (
                    <div className="create_controller-nodata">
                      <img
                        src={emptyFolter}
                        alt="nodata"
                        width="120"
                        height="120"
                      />
                      <h3>No Record Found!</h3>
                    </div>
                  )}
                </div>
              </div>
              {categoryList?.length > 0 && (
                <Pagination
                  rowsPerPageOptions={[5, 10, 20, 30]}
                  currentPage={currentPage}
                  onPageChange={handlePageChange}
                  onRowsPerPageChange={handleRowsPerPageChange}
                  totalPages={totalPages}
                />
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Category;
